import React, {useEffect, useState} from "react";
import {Bar} from "react-chartjs-2";
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from "chart.js";
import {getJobcardTurnaroundForWorkshop} from "../../../Api/Api";

// Register necessary chart components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const JobTurnaroundChart = ({ workshopId }) => {
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        fetchTurnaroundData();
    }, [workshopId]);

    const fetchTurnaroundData = async () => {
        try {
            getJobcardTurnaroundForWorkshop(workshopId)
                .then(response => {
                    const data = response.data.map((entry) => ({
                        month: `${entry.month}/${entry.year}`,
                        avgTime: entry.avgTurnaroundTime.toFixed(2),
                    }));

                    setChartData({
                        labels: data.map((d) => d.month),
                        datasets: [
                            {
                                label: "Avg Turnaround Time (Minutes)",
                                data: data.map((d) => d.avgTime),
                                backgroundColor: "rgba(75, 192, 192, 0.6)",
                                borderColor: "rgba(75, 192, 192, 1)",
                                borderWidth: 1,
                            },
                        ],
                    });
                })
                .catch(error => console.error("Error fetching data:", error));


        } catch (error) {
            console.error("Error fetching turnaround data", error);
        }
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-lg mb-6">
            <h2 className="text-xl font-semibold mb-4">Job Turnaround Time (Monthly)</h2>
            {chartData ? <Bar data={chartData}  /> : <p>Loading...</p>}
        </div>
    );
};

export default JobTurnaroundChart;
